import BiasItem from './BiasItem';

export default BiasItem;
